import React, { useEffect, useState } from 'react'
import { TextField } from '@mui/material'

import { useDebounce } from '../hooks'

export interface DebouncedTextFieldProps {
  label: string
  onChange(value?: string): void
  delay?: number
  doReset?: boolean
  initValue?: string
}

export const DebouncedTextField = ({
  label,
  onChange,
  delay = 300,
  doReset,
  initValue = '',
}: DebouncedTextFieldProps): React.ReactElement => {
  const [value, setValue] = useState<string>(initValue)
  const debouncedValue = useDebounce(value, delay)

  useEffect(() => {
    onChange(value)
  }, [debouncedValue])

  useEffect(() => {
    if (doReset) {
      setValue('')
    }
  }, [doReset])

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => setValue(event.target.value)

  return <TextField label={label} onChange={handleChange} fullWidth value={value} />
}
